'use strict'

module.exports = {
  inferno: require('./inferno'),
  magma: require('./magma'),
  plasma: require('./plasma'),
  viridis: require('./viridis')
}



//////////////////
// WEBPACK FOOTER
// ./~/scale-color-perceptual/browser.js
// module id = 848
// module chunks = 0